module.exports = __webpack_public_path__ + "img/Yuutrak_bk.43826396.png";